"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const checkbox_styles_1 = require("@/components/common/checkbox/checkbox.styles");
const input_styles_1 = require("@/components/common/input/input.styles");
const toggle_controller_1 = require("@/controllers/toggle-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common/text/semantics/paragraph");
let Checkbox = class Checkbox extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.checked = false;
        this.disabled = false;
        this.indeterminate = false;
        // SSR 환경 및 crypto가 없는 구형 환경에서도 터지지 않도록 고유 ID 생성을 보장합니다.
        this.inputId = (0, utils_1.uniqueId)('checkbox');
        this.toggle = new toggle_controller_1.ToggleController(this, 'checked');
        this.handleCheckboxChange = (event) => {
            const target = event.target;
            // 네이티브 체크박스처럼 누르면 indeterminate가 먼저 풀린 뒤 change가 나간다.
            this.indeterminate = false;
            this.toggle.set(target.checked);
        };
    }
    render() {
        // 가독성을 위한 구조 분해 할당
        const { name, value, checked, disabled, indeterminate, inputId } = this;
        return (0, lit_1.html) `
      <div>
        <input
          type="checkbox"
          id=${inputId}
          name=${(0, if_defined_js_1.ifDefined)(name)}
          .value=${value || ''}
          .checked=${checked}
          .indeterminate=${indeterminate}
          ?disabled=${disabled}
          @change=${this.handleCheckboxChange}
        />

        <label for=${inputId}>
          <span class="indicator"></span>
          <mm-paragraph>
            <slot></slot>
          </mm-paragraph>
        </label>
      </div>
    `;
    }
};
Checkbox.styles = [shared_styles_1.resetStyles, input_styles_1.visuallyHiddenInputStyles, checkbox_styles_1.checkboxStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Checkbox.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Checkbox.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Checkbox.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Checkbox.prototype, "checked", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], Checkbox.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], Checkbox.prototype, "indeterminate", void 0);
Checkbox = __decorate([
    (0, decorators_js_1.customElement)('mm-checkbox')
], Checkbox);
exports.Checkbox = Checkbox;
//# sourceMappingURL=data:application/json;base64,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